const ScrollToTop = () => {
    window.scrollTo(0, 0);
};

export default ScrollToTop;
